import cookie from 'js-cookie';

import { browserOnly, getCookieDomain } from '@farmersdog/utils';

export const LEAD_CAPTURE_DISMISS_COOKIE = 'lead-capture-dismiss';
const LEAD_CAPTURE_EXPIRES_DAYS = 1; // 1 day

/**
 * Set a cookie to mark when the lead capture modal was dismissed.
 * The cookie expires after 24 hours.
 */
export function setLeadCaptureCookie(): void {
  browserOnly(() => {
    cookie.set(LEAD_CAPTURE_DISMISS_COOKIE, 'true', {
      expires: LEAD_CAPTURE_EXPIRES_DAYS,
      domain: getCookieDomain(),
      path: '/',
    });
  });
}

/**
 * Get the lead capture dismiss cookie value.
 * Returns 'true' if the cookie exists, undefined otherwise.
 */
export function getLeadCaptureCookie(): string | undefined {
  return cookie.get(LEAD_CAPTURE_DISMISS_COOKIE);
}
